import { Inertia } from '@inertiajs/inertia'
import { InertiaLink } from '@inertiajs/inertia-react'
import EditIcon from '@mui/icons-material/Edit'
import PageviewIcon from '@mui/icons-material/Pageview'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import { useTranslation } from 'react-i18next'
import ButtonChangeStatus from '../../../../components/ButtonChangeStatus'
import DataGrid from '../../../../components/organisms/DataGrid/DataGrid'
import { STATUS } from '../../../../constant/StatusConstant'

export default function MerchantIndex({ merchants, categories }) {
  const { t } = useTranslation()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DataGrid
          enableIndexColumn
          columns={[
            {
              id: 'name',
              Header: t('MERCHANTS.NAME'),
              accessor: 'name',
              type: 'string',
            },
            {
              id: 'vouchers_count',
              Header: t('MERCHANTS.TOTAL_VOUCHERS'),
              accessor: 'vouchers_count',
              type: 'number',
              autoHide: true,
            },
            {
              id: 'codes_count',
              Header: t('MERCHANTS.TOTAL_CODE'),
              accessor: 'codes_count',
              type: 'number',
              autoHide: true,
            },
            {
              id: 'pos_count',
              Header: t('MERCHANTS.TOTAL_POS'),
              accessor: 'pos_count',
              type: 'number',
              disableFilters: true,
              autoHide: true,
            },
            {
              id: 'categories',
              Header: t('MERCHANTS.CATEGORY'),
              accessor: 'categories',
              type: 'multichip',
              options: categories,
              disableSortBy: true,
            },
            {
              id: 'status',
              Header: t('MERCHANTS.STATUS'),
              accessor: ({ status }) => t(`MERCHANTS.${status.toUpperCase()}`),
              type: 'singleSelect',
              options: [
                { value: STATUS.ACTIVE, name: t('MERCHANTS.ACTIVE') },
                { value: STATUS.IN_ACTIVE, name: t('MERCHANTS.INACTIVE') },
              ],
              Cell: ({ row }) => (
                <ButtonChangeStatus
                  handleSubmit={() => {
                    Inertia.get(
                      route('admin.merchants.status.change', { merchant: row.original.id, status: row.original.status })
                    )
                  }}
                  row={row}
                  tableName={t('MERCHANTS.MERCHANT_TABLE')}
                />
              ),
            },
            {
              id: 'actions',
              Header: t('MERCHANTS.ACTIONS'),
              disableFilters: true,
              align: 'center',
              cell: {
                style: { whiteSpace: 'nowrap' },
              },
              Cell: ({ row }) => (
                <>
                  <IconButton component={InertiaLink} href={route('admin.merchants.show', row.original.id)}>
                    <PageviewIcon />
                  </IconButton>
                  <IconButton component={InertiaLink} href={route('admin.merchants.edit', row.original.id)}>
                    <EditIcon />
                  </IconButton>
                </>
              ),
            },
          ]}
          data={merchants}
          routeName="admin.merchants.index"
        />
      </Grid>
    </Grid>
  )
}
